// Reine Rechnung der Seite „Ereignisse" (System → Ereignisse), nach
// docs/gestaltung.md umgebaut am 03.10.2026. Ohne Svelte, damit testbar
// (lib/ereignisse.test.mjs).
//
// Ereignisse sind ein Protokoll: ein Fehler-Ereignis ist ein Hinweis zum
// Hinsehen (gelb), kein Zustand -- offene Störungen stehen in Meldungen.
// Der Bereich ist eine Kategorie und trägt keine Farbe (Schild).

import type { LageTeil } from "../lage";

export interface Ereignis {
  id: number;
  ts: string;
  domain: string;
  type: string;
  severity: string;
  actor?: string;
  entity?: string;
  summary: string;
  attrs?: unknown;
  acked_at?: string;
}

export type Stufe = "alle" | "warn" | "fehler";

export function istFehler(sev: string): boolean {
  return sev === "error" || sev === "critical" || sev === "danger";
}
export function istWarnung(sev: string): boolean {
  return sev === "warn" || sev === "warning";
}

/** Art lesbar: "task_failed" → "task failed". */
export function artText(type: string): string {
  return type.replace(/_/g, " ");
}

export function artTon(sev: string): "" | "warn" | "danger" {
  if (istFehler(sev)) return "danger";
  if (istWarnung(sev)) return "warn";
  return "";
}

/** Server-Parameter für eine Stufe: die events-API nimmt severity als CSV. */
export function severityParam(stufe: Stufe): string {
  if (stufe === "fehler") return "error,critical";
  if (stufe === "warn") return "warn,error,critical";
  return "";
}

export function ereignisLage(evs: Pick<Ereignis, "severity">[]): LageTeil[] {
  const fehler = evs.filter((e) => istFehler(e.severity)).length;
  const warn = evs.filter((e) => istWarnung(e.severity)).length;
  const teile: LageTeil[] = [];
  if (fehler) teile.push({ text: `${fehler} Fehler`, ton: "warn" });
  else if (evs.length) teile.push({ text: "keine Fehler", ton: "ok" });
  if (warn) teile.push({ text: `${warn} ${warn === 1 ? "Warnung" : "Warnungen"}` });
  return teile;
}
